import { topicsItems } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-800 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            当前最受关注的话题赛道，点击参与创作竞技
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsItems.map((item, idx) => (
              <a
                key={idx}
                href="#carousel"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer no-underline whitespace-nowrap ${colorMap[item.color] || colorMap.primary}`}
              >
                {item.tag}
                <span className="text-xs opacity-70">{item.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}